export default __webpack_public_path__ + "images/628feaf252d96f4354b3dd66d552084b-EE_SlideDeckBOOK1024_4.png";